import { EventType } from 'types/EventState';
import { EVENT_TYPE_PAID } from 'utils/static/constants';

export const sellerInitialData = {
  name: '',
  description: '',
  avatar: '',
};
export const initialDateTimeFormat = {
  dateFormat: '',
  timeFormat: '',
  timezone: '',
};

export const initialTimeInterval = {
  startsAt: '',
  endsAt: '',
};

export const initialSelectedEvent = {
  id: '',
  name: '',
  description: '',
  status: '',
  timeInterval: initialTimeInterval,
  location: '',
  coordinates: {
    longitude: 0,
    latitude: 0,
  },
  dateTimeFormat: initialDateTimeFormat,
  cover: null,
  gallery: [],
  seller_public_information: sellerInitialData,
  sellerFeatures: {
    hasMarketplaceCustomLogo: false,
    hideFooter: false,
    hasEnabledPO: false,
    byDefaultOpenCompanyTab: false,
    displayCalendarInsidePageLayout: false,
  },
  tickets: [],
  ticketTypeGroups: [],
  currency: '',
  id_seller: '',
  customerform: null,
  hasRegistrationForm: false,
  walletcredit: [],
  hasVoucher: false,
  numberOfPublicTicketTypes: 0,
  numberOfPrivateTicketTypes: 0,
  tax_included: false,
  fee_included: false,
  topup_tax_included: false,
  minmaxticketsprices: null,
  tax_rate: {
    rate: 0,
    name: '',
  },
  fees: {
    percent: 0,
    min: 0,
    currency: '',
  },
  fee_tax_rate: {
    rate: 0,
    name: '',
  },
  gtm_code: '',
  type: EVENT_TYPE_PAID as EventType,
  checkoutConfiguration: {
    displayAvailability: false,
  },
};

export const initialVoucherData = {
  id: '',
  name: '',
  discount: 0,
  currency: '',
  discount_percent: false,
};

export const initialVoucherCodeData = {
  id: '',
  code: '',
  uses: 0,
  claimed: 0,
};

export const initialVoucher = {
  loading: false,
  status: 'unchecked',
  voucherData: initialVoucherData,
  voucherCode: initialVoucherCodeData,
  voucherApplicableTickets: [],
  voucherError: null,
};

export const initialCountdownData = {
  onGoing: false,
  endTime: '',
  vendorId: '',
  eventId: '',
};

export const initialBillingData = {
  email: '',
  billing: {
    type: '',
    name: '',
    company: '',
    address: {
      address: '',
      city: '',
      id_country: '',
      id_state: '',
      tax_code: '',
      purchaseOrderNumber: '',
    },
  },
  fields: {},
};
